import React from "react";
import styled, { css } from "styled-components";

import { colorFromTheme } from "../../utils/color";

export const ListTable = styled.table<{ zebra?: boolean }>`
  table-layout: fixed;

  caption {
    text-align: left;
    font-size: 1.4rem;
    font-weight: 500;

    padding-block: 1rem;
  }

  thead > tr > th {
    text-align: left;
    color: #666;
    font-weight: normal;
  }

  // this is purposefully low specificity so that it can be overridden
  td {
    padding-block: 0.4rem;
  }

  ${(props) =>
    props.zebra
      ? css`
          tbody tr:nth-child(2n) {
            background-color: ${colorFromTheme("surface3")};
          }
        `
      : ""}
`;

// use at the end of your <thead> to add a visual divider between the header
// and the body
export const ListTableHeaderLine = () => {
  return (
    <tr>
      <th colSpan={99}>
        <hr style={{ border: "1px solid #d8d8d8" }} />
      </th>
    </tr>
  );
};
